import bugsnag from '@app/utils/bugsnag/bugsnag'
import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

import { type AppType, type ContentEngineAppSlug, isValidContentEngineAppSlug } from './types'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const AppManagement = lazy(() => import('./Management'))

class AppsManagementComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['project-id', 'app-slug', 'type']
	}

	override render() {
		const projectId = this.prop('project-id')
		const rawSlug = this.prop('app-slug')
		const type: AppType = this.prop('type') as AppType

		// Validate slug but continue rendering even if invalid
		if (!isValidContentEngineAppSlug(rawSlug)) {
			bugsnag.log(`Invalid app-slug received: ${rawSlug}`)
		}

		const slug = rawSlug as ContentEngineAppSlug

		return (
			<RootProviders>
				<AppManagement projectId={projectId} slug={slug} type={type} />
			</RootProviders>
		)
	}
}

customElements.define('apps-management', AppsManagementComponent)
